<template>
    <div>
        <div class="scheduled-status"><i class="el-icon-check"></i></div>
    </div>
</template>

<script>

export default {

    components: {

    },

    props: {

    },

    data (){
        return {

        };
    },

    computed: {

    },

    mounted (){

    },

    methods: {
    },
};
</script>

<style lang="scss">
.scheduled-status{
    .el-icon-check{
        font-size: 35px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Channels/configurationButton/check-btn.vue